import React from 'react';
import type { SnapSelectMenuOptionType } from '.';
import {
  DialogPanel,
  Dialog as HeadlessDialog,
  // Transition,
  // TransitionChild,
} from '@headlessui/react';
import { EmptyState } from './EmptyState';
import { ColorSwatch } from './ColorSwatch';
function classNames(...classes: string[]): string {
  return classes.filter(Boolean).join(' ');
}

type Props = {
  selectOptions: SnapSelectMenuOptionType[];
  open: boolean;
  setOpen: (boolean: boolean) => void;
  header: string;
  onSelect: (option: SnapSelectMenuOptionType) => void;
  fullHeight?: boolean;
  loading: boolean;
  mobile?: boolean;
};

export const MobileMenu: React.FC<Props> = (props) => {
  const {
    selectOptions,
    open,
    setOpen,
    header,
    onSelect,
    fullHeight = false,
    loading,
  } = props;

  return (
    // <Transition show={open} as={React.Fragment}>
    <HeadlessDialog
      id='dialog-main'
      as='div'
      className='block md:hidden relative z-50 bg-fixed'
      onClose={setOpen}
      open={open}
    >
      {/* <TransitionChild
        enter='transition-opacity ease-linear duration-300'
        enterFrom='opacity-0'
        enterTo='opacity-100'
        leave='transition-opacity ease-linear duration-300'
        leaveFrom='opacity-100'
        leaveTo='opacity-0'
      > */}
      <div className='fixed inset-0 bg-black/30' aria-hidden='true' />
      {/* </TransitionChild> */}

      <div className='fixed inset-0 z-10'>
        <div className='flex h-full flex-col flex-wrap max-h-full justify-end p-0'>
          {/* <TransitionChild
            as={React.Fragment}
            enter='transition ease-in-out duration-300 transform'
            enterFrom='-bottom-full'
            enterTo='bottom-0'
            leave='transition ease-in-out duration-300 transform'
            leaveFrom='bottom-0'
            leaveTo='-bottom-full'
          > */}
          <DialogPanel
            className={`relative overflow-y-auto transform p-0 shadow-xl transition-all w-full ${
              fullHeight ? 'min-h-full' : 'max-h-[90%] rounded-t-2xl'
            } bg-white`}
          >
            <div className='sticky z-10 top-0 px-4 pt-4 pb-3 border-b mb-4 bg-white'>
              <div className='flex justify-between'>
                <span className='font-semibold'>{header}</span>
                <button
                  className='cursor-pointer'
                  type='button'
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <svg
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <title>close button</title>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M5.15164 5.1516C5.37667 4.92664 5.68184 4.80026 6.00004 4.80026C6.31823 4.80026 6.6234 4.92664 6.84844 5.1516L12 10.3032L17.1516 5.1516C17.2623 5.03699 17.3947 4.94557 17.5412 4.88268C17.6876 4.81979 17.845 4.78669 18.0044 4.7853C18.1637 4.78392 18.3217 4.81428 18.4692 4.87462C18.6167 4.93495 18.7506 5.02406 18.8633 5.13673C18.976 5.2494 19.0651 5.38338 19.1254 5.53086C19.1858 5.67833 19.2161 5.83635 19.2147 5.99568C19.2134 6.15502 19.1803 6.31248 19.1174 6.45889C19.0545 6.60529 18.963 6.7377 18.8484 6.8484L13.6968 12L18.8484 17.1516C19.067 17.3779 19.188 17.681 19.1852 17.9957C19.1825 18.3103 19.0563 18.6113 18.8338 18.8338C18.6113 19.0563 18.3104 19.1825 17.9957 19.1852C17.6811 19.1879 17.378 19.067 17.1516 18.8484L12 13.6968L6.84844 18.8484C6.62211 19.067 6.31899 19.1879 6.00436 19.1852C5.68972 19.1825 5.38874 19.0563 5.16625 18.8338C4.94376 18.6113 4.81756 18.3103 4.81483 17.9957C4.81209 17.681 4.93305 17.3779 5.15164 17.1516L10.3032 12L5.15164 6.8484C4.92667 6.62337 4.80029 6.3182 4.80029 6C4.80029 5.6818 4.92667 5.37663 5.15164 5.1516Z'
                      fill='#64748B'
                    />
                  </svg>
                </button>
              </div>
            </div>
            {/* List */}
            {selectOptions.length > 0 ? (
              <div className='flex flex-col gap-y-0.5'>
                {selectOptions.map((option) =>
                  option.type === 'header' ? (
                    <span
                      className='px-4 py-2 bg-gray-200 w-full font-semibold'
                      key={option.value}
                    >
                      {option.name}
                    </span>
                  ) : (
                    <button
                      type='button'
                      key={option.id}
                      onClick={() => onSelect(option)}
                      className={classNames(
                        'flex justify-start shadow-none w-full text-left md:font-light',
                        option.selected ? 'bg-blue-100' : '',
                        'relative cursor-default select-none py-1.5 my-1 pl-3 pr-9 hover:bg-blue-200 active:bg-blue-200',
                      )}
                    >
                      {option.color ? (
                        <ColorSwatch color={option.color} />
                      ) : null}
                      {option.name}
                    </button>
                  ),
                )}
              </div>
            ) : (
              <EmptyState loading={loading} />
            )}
          </DialogPanel>
          {/* </TransitionChild> */}
        </div>
      </div>
    </HeadlessDialog>
    // </Transition>
  );
};
